<template>
  <div class="content-container">
    <div class="content">
      <z-icon name="passed" class="result-succ-icon"/>
      <h3 class="result-title">提交成功</h3>
      <p class="result-desc">我们会在24~72小时内审核请耐心等待处理结果</p>
    </div>
  </div>
</template>

<script>
import { Icon } from '@zz-common/zz-ui';
export default {
  name: 'ProductResult',
  components: {
    zIcon: Icon
  }
}

</script>
<style lang="less">
  @import 'result.less';
</style>